// extracted by mini-css-extract-plugin
export default {"wrap":"tz-z","logoContainer":"uz-z","brandImg":"vz-z","logoImg":"wz-z","logoButton":"xz-z"};